import type { ComponentType } from 'react';
import type { SeasonDefinition } from './types';
import HalloweenLayer from './halloween/HalloweenLayer';
import { HalloweenHeroScene, HalloweenNotFoundArt } from './halloween/HalloweenSlots';
import './halloween/halloween.css';

// The client half of a look: its decorative layer, mounted behind the page
// while the season is on, and the pieces it lends to named slots in pages
// (`<SeasonalSlot name="hero" />`). Each look's stylesheet is scoped entirely
// under `[data-season="<look>"]`, so importing it here changes nothing until a
// season with that look is active.
export interface SeasonLook {
  Layer?: ComponentType<{ season: SeasonDefinition }>;
  slots?: Record<string, ComponentType>;
}

export const LOOKS: Record<string, SeasonLook> = {
  halloween: {
    Layer: HalloweenLayer,
    slots: {
      hero: HalloweenHeroScene,
      'not-found': HalloweenNotFoundArt,
    },
  },
};
